<template>
  <ModalDialog
    ref="dialog"
    :title="title"
    icon="fa-box"
    sizeClass="modal-med"
    :submitting="submitting"
    :submitTitle="submitTitle"
    :showSubmit="true"
    @closed="onClosed"
    @submitted="onSubmitted">

    <LoadingPanel :loading="loading" :loadingError="loadingError" />
    <FormGroup v-bind:form="dialogForm" v-if="!loading">
      <NotificationBar type="info">
        <NotificationBarTitle>Glass Block Updates</NotificationBarTitle>
        <ul>
          <li>This will <strong>not</strong> update any sheet counts in inventory.</li>
          <li>If sheet counts modifications are required, please create a manual stock transaction to adjust them first</li>
        </ul>        
      </NotificationBar>

      <ContentTitle>Block Details</ContentTitle>
      <FormRow label="Stock" v-if="glassBlock.stock">
        <FormStaticLabel>{{glassBlock.stock.name }}</FormStaticLabel>        
      </FormRow>
      <FormRow label="Size">
        <FormStaticLabel>{{glassBlock.height}} x {{glassBlock.width}}</FormStaticLabel>        
      </FormRow>
      <FormRow label="Supplier">
        <ContactSearchableSelect v-model="glassBlock.contactId" field="contactId" />
      </FormRow>
      <FormRow label="Batch Number">
        <FormInputText v-model="glassBlock.referenceCode" field="referenceCode" />
      </FormRow>
      <FormRow label="Sheet Quantity">
        <FormInputText type="number" v-model="glassBlock.sheetQuantity" field="sheetQuantity" />
      </FormRow>
    </FormGroup>
  </ModalDialog>
</template>


<script>
import _ from 'lodash'

import form from '@/mixins/form'

import ModalDialog from '@/components/modalDialog.vue'
import ModalDialogMixin from '@/mixins/modalDialog'

import ContactSearchableSelect from '@/modules/contacts/components/contactSearchableSelect.vue'

import { InventoryStockTypes } from '@/store/types'

export default {
  name: 'GlassBlockEditDialog',
  mixins: [form, ModalDialogMixin],
  components: {
    ModalDialog,
    ContactSearchableSelect
  },
  props: {
    glassBlockId: Number
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      loadingStock: false,
      dialogForm: {},
      glassBlock: {
        stockId: null,
        contactId: null,
        referenceCode: '',
        sheetQuantity: 0
      },
      submitting: false
    };
  },
  computed: {
    title() {
      return 'Update Glass Block'
    },
    submitTitle() {
      return 'Update'
    }
  },
  created() {
    this.InventoryStockTypes = InventoryStockTypes
    
  },
  mounted() {
    this.requestData()
  },
  methods: {
    show(options = {}) {
      // Reset form
      this.dialogForm = { }

      return ModalDialogMixin.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(false)
    },
    onSubmitted() {
      this.submitting = true

      var updateData = _.pick(this.glassBlock, [
        'contactId',
        'referenceCode',
        'sheetQuantity'
      ])

      this.$apiService.inventoryService.updateGlassBlock(this.glassBlockId, updateData)
      .then(response => {
        this.submitting = false
        this.modalClosed(true)
        this.hide()
      })
      .catch(err => {
        this.submitting = false
        this.$data.dialogForm = this.processFormResponse(err)
      })
    },
    requestData() {
      this.loading = true

      this.$apiService.inventoryService.getGlassBlock(this.glassBlockId)
      .then(response => {
        this.glassBlock = response.data
      })
      .catch(err => {
        console.error(err)
        this.loadingError = this.processFormResponse(err).errorMessage
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>